export default __webpack_public_path__ + "static/media/1.1a6629da.mp3";